import React from 'react';
import { Button, FormGroup, HelpBlock, Image, Panel } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { Link } from '../Link.jsx';
import FieldGroup from '../FieldGroup.jsx';

function ForgotPasswordForm(props) {
  return (
    <Panel>
      <Panel.Body>
        <Link route="index">
          <a title="Sign in">
            <Image
              alt="ChangeSync Logo"
              className="component-margin-bottom"
              src="/static/images/logo.svg"
              responsive
            />
          </a>
        </Link>
        <p className="component-margin-bottom text-center">
          Enter the email address associated with your account to receive an
          email with a link to reset your password.
        </p>
        <form onSubmit={props.handleSubmit}>
          <Field
            id="email"
            name="email"
            label="Email"
            type="email"
            component={FieldGroup}
            disabled={props.submitSucceeded}
          />
          {props.submitFailed && (
            <FormGroup validationState="error">
              <HelpBlock>{props.submitError}</HelpBlock>
            </FormGroup>
          )}
          {props.submitSucceeded && (
            <FormGroup>
              <HelpBlock>
                Check your email for the link to reset your password.
              </HelpBlock>
            </FormGroup>
          )}
          <Button
            block
            bsSize="lg"
            bsStyle="primary"
            disabled={props.submitting || props.submitSucceeded}
            type="submit"
          >
            {!props.submitting &&
              !props.submitSucceeded &&
              'Request Password Reset'}
            {props.submitting && 'Requesting Reset...'}
            {props.submitSucceeded && 'Password Reset Requested'}
          </Button>
        </form>
      </Panel.Body>
    </Panel>
  );
}

export default ForgotPasswordForm;
